function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.522 1.88402L8 0.666687L13.478 1.88402C13.626 1.91693 13.7584 1.99933 13.8533 2.11762C13.9482 2.23592 14 2.38303 14 2.53469V9.19269C14 9.85118 13.8373 10.4995 13.5266 11.08C13.2158 11.6606 12.7666 12.1554 12.2187 12.5207L8 15.3334L3.78133 12.5207C3.23352 12.1555 2.78431 11.6608 2.47357 11.0803C2.16282 10.4999 2.00016 9.85173 2 9.19335V2.53469C2.00003 2.38303 2.05176 2.23592 2.14666 2.11762C2.24156 1.99933 2.37396 1.91693 2.522 1.88402ZM7.33333 6.66669H5.33333V8.00002H7.33333V10H8.66667V8.00002H10.6667V6.66669H8.66667V4.66669H7.33333V6.66669Z",
  fill: "#333333"
});

var SvgShield = function SvgShield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield.cd1cfa5d.svg";
export { ForwardRef as ReactComponent };